import { createFileRoute, stripSearchParams } from "@tanstack/react-router"
import {
	MarketDataPage,
	type MarketDataTab,
} from "@/components/pages/market-data"
import {
	CMI_WEEKLY_RANGE_DAYS,
	DEFAULT_RANGE_DAYS,
} from "@/components/pages/market-data/constants"
import { priceSeriesOptions } from "@/hooks/queries/market-data"
import { useTabNavigation } from "@/hooks/use-tab-navigation"

const TABS = new Set<MarketDataTab>([
	"carbon",
	"commodities",
	"bunkers",
	"fx",
	"storage",
	"emissions",
])

const defaultSearch = { tab: "" }

export const Route = createFileRoute("/_authenticated/market-data")({
	validateSearch: (search: Record<string, unknown>) => ({
		tab:
			typeof search.tab === "string" && TABS.has(search.tab as MarketDataTab)
				? (search.tab as MarketDataTab)
				: "",
	}),
	search: {
		middlewares: [stripSearchParams(defaultSearch)],
	},
	loader: ({ context }) => {
		context.queryClient.prefetchQuery(
			priceSeriesOptions(["CMI"], CMI_WEEKLY_RANGE_DAYS),
		)
		context.queryClient.prefetchQuery(
			priceSeriesOptions(["EUA"], DEFAULT_RANGE_DAYS),
		)
	},
	component: MarketDataRoute,
})

function MarketDataRoute() {
	const { tab: tabSearch } = Route.useSearch()
	const navigate = Route.useNavigate()
	const { tab, onTabChange } = useTabNavigation<MarketDataTab>(
		navigate,
		"carbon",
		tabSearch,
	)

	return <MarketDataPage tab={tab} onTabChange={onTabChange} />
}
